import type { ViewscreenMode } from "../../types/game";

const MODE_LABELS: Partial<Record<ViewscreenMode["mode"], string>> = {
  tactical: "TACTICAL VIEW",
  magnify: "MAGNIFICATION",
  surface_map: "SURFACE MAP",
  scan_readout: "SCAN READOUT",
  chart: "STAR CHART",
  recording: "RECORDING",
};

export function ViewscreenLabel({ mode }: { mode: ViewscreenMode["mode"] }) {
  const label = MODE_LABELS[mode];
  if (!label) return null;

  return (
    <div className="viewscreen-mode-label">
      <span className="viewscreen-mode-label-dot" />
      {label}
    </div>
  );
}
